import React from "react";
import { useLocation, useParams } from "react-router-dom";

import SkillCollection from "@/components/SkillCollection";

const SkillCollectionPage: React.FC = () => {
  const { workspaceId, collectionId, versionNumber } = useParams();
  const location = useLocation();

  const workspaceIdNum = workspaceId ? parseInt(workspaceId, 10) : null;
  const collectionIdStr = collectionId ?? null;
  const routeVersionNumber = versionNumber ? parseInt(versionNumber, 10) : null;
  const isEditing = location.pathname.endsWith("/edit");

  return (
    <SkillCollection
      isEditing={isEditing}
      workspaceIdNum={workspaceIdNum}
      collectionIdStr={collectionIdStr}
      routeVersionNumber={routeVersionNumber}
    />
  );
};

export default SkillCollectionPage;
